import { propClassName } from '@/styles/TextField';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';

export interface TextFieldLabelProps extends ComponentProps<'label'> {
  colors?: ClassNameProp<'primary'>;
  size?: ClassNameProp<'default' | 'alternative'>;
  variant?: ClassNameProp<'default' | 'alternative'>;
}

export const TextFieldLabelComponent: Component<TextFieldLabelProps> = ({
  children,
  className,
  size,
  colors,
  variant,
  ...props
}) => {
  const colorsClassName = propClassName('label_colors', colors, 'primary');
  const sizeClassName = propClassName('label_size', size ?? variant, 'default');
  const variantClassName = propClassName('label_variant', variant, 'default');
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <label className={componentClassName} {...props}>
      {children}
    </label>
  );
};
